import "./Skills.css";
// import react from "../skill logo/react.png";
// import redux from "../skill logo/redux.png";
// import css from "../skill logo/css.png";
// import html from "../skill logo/html.png";
// import docker from "../skill logo/docker.png";
// import redis from "../skill logo/redis.png";
// import sql from "../skill logo/sql.png";
// import bootstrap from "../skill logo/bootstrap.png";
// import cpp from "../skill logo/cpp.png";
// import js from "../skill logo/js.png";
// import c from "../skill logo/c.png";
// import mongo from "../skill logo/mongo.png";
// import nodejs from "../skill logo/nodejs.png";
// import aws from "../skill logo/aws.png";
// import axios from "../skill logo/axios.png";
// import restapi from "../skill logo/restapi.png";

function Skills() {
  return (
    <div>
      <br></br>
      <br></br>
      {/* <div className="skills" id="skills">
        <h1 className="skill-h1">Skills</h1>
        <span className="skills-span">
          <img alt="skills" src={html}></img>
          <span className="skill-name">HTML</span>
        </span>
        <span className="skills-span">
          <img alt="skills" src={css}></img>
          <span className="skill-name">CSS</span>
        </span>
        <span className="skills-span">
          <img alt="skills" src={js}></img>
          <span className="skill-name">JavaScript</span>
        </span>
        <span className="skills-span">
          <img alt="skills" src={bootstrap}></img>
          <span className="skill-name">Bootstrap</span>
        </span>
        <span className="skills-span">
          <img alt="skills" src={react}></img>
          <span className="skill-name">React</span>
        </span>
        <span className="skills-span">
          <img alt="skills" src={redux}></img>
          <span className="skill-name">Redux</span>
        </span>
        <span className="skills-span">
          {" "}
          <img alt="skills" src={cpp}></img>
          <span className="skill-name">C++</span>
        </span>
      
        <span className="skills-span">
          <img alt="skills" src={c}></img>
          <span className="skill-name">C</span>
        </span>
        <span className="skills-span">
          <img alt="skills" src={mongo}></img>
          <span className="skill-name">MongoDB</span>
        </span>
        <span className="skills-span">
          <img alt="skills" src={nodejs}></img>
          <span className="skill-name">Node js</span>
        </span>
        <span className="skills-span">
          <img alt="skills" src={sql}></img>
          <span className="skill-name">SQL</span>
        </span>
      
        <span className="skills-span">
          <img alt="skills" src={axios}></img>
          <span className="skill-name">Axios</span>
        </span>
        <span className="skills-span">
          <img alt="skills" src={restapi}></img>
          <span className="skill-name">Rest API</span>
        </span>
        <span className="skills-span">
          <img alt="skills" src={aws}></img>
          <span className="skill-name">AWS services</span>
        </span>
        <span className="skills-span">
          <img alt="skills" src={docker}></img>
          <span className="skill-name">Docker</span>
        </span>
        <span className="skills-span">
          <img alt="skills" src={redis}></img>
          <span className="skill-name">Redis</span>
        </span>
        <span id="skills-head">Skills</span>
      </div> */}
      <h1 className="skillTitle">What I Know</h1>
      <div className=" container skillContainer">
        <div className="skillBox ">
          <h1 className="skillHead">Frontend</h1>
          <div className=" skillWrapper">
            <p>HTML</p>
            <p>CSS</p>
            <p>ReactJs</p>
            <p>Next js</p>
            <p>Redux</p>
            <p>TypeScript</p>
            <p>JavaScript</p>
            <p>Tailwindcss</p>
          </div>
        </div>
        <div className="skillBox ">
          <h1 className="skillHead">Backend</h1>
          <div className=" skillWrapper">
            <p>Node Js</p>
            <p>Express Js</p>
            <p>JWT Auth</p>
            <p>Rest API</p>
            <p>MongoDb</p>
            <p>PostgreSQL</p>
            <p>Redis</p>
          </div>
        </div>
        <div className="skillBox ">
          <h1 className="skillHead">Devops</h1>
          <div className=" skillWrapper">
            <p>Kubernetes</p>
            <p>Docker</p>
            <p>Git</p>
            <p>Jenkins</p>
            
          </div>
        </div>
        <div className="skillBox ">
          <h1 className="skillHead">AWS</h1>
          <div className=" skillWrapper">
            <p>EC2</p>
            <p>RDS</p>
            <p>Lambda function</p>
            <p>S3</p>
            {/* <p>CloudWatch</p> */}
           
          </div>
        </div>
      </div>
    </div>
  );
}

export default Skills;
